// extracted by mini-css-extract-plugin
export default {"cont":"NewUserForm_cont__l50V5"};